import type { FunctionComponent, PropsWithChildren } from 'react';

import type { FeatureFlagService } from '~/shared/feature-flag-service/feature-flag-service';

import { useFeatureFlagInitialization } from './query-hooks/feature-flags';

type FeatureFlagInitializerProperties = PropsWithChildren<{
    readonly featureFlagService: FeatureFlagService;
}>;

export const FeatureFlagInitializer: FunctionComponent<FeatureFlagInitializerProperties> = (properties) => {
    const { children, featureFlagService } = properties;
    const featureFlagInitializationQuery = useFeatureFlagInitialization(featureFlagService);

    if (featureFlagInitializationQuery.isPending) {
        return null;
    }

    return children;
};
